/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let progressBar = document.querySelector('.progress-bar');
if(progressBar){
    let flkty = new Flickity('.Carousel');

    flkty.on( 'scroll', function( progress ) {
    progress = Math.max( 0, Math.min( 1, progress ) );
    progressBar.style.width = progress * 100 + '%';
    });
}

class Dropdown {
    constructor(container) {
      this.isOpen = false;
      this.activeIndex = undefined;
  
      this.container = container;
      this.button = container.querySelector(".Collapsible__Button");
      this.menu = container.querySelector(".Collapsible__Inner");
      this.items = container.querySelectorAll(".HorizontalList__Item");
    }
  
    initEvents() {
      if(this.button){
        this.button.addEventListener("click", this.toggle.bind(this));
      }
      document.addEventListener("click", this.onClickOutside.bind(this));
      document.addEventListener("keydown", this.onKeyEvent.bind(this));
    }
  
    toggle() {
      if(!document.querySelector('.PageOverlay.is-visible')) {
        this.isOpen = !this.isOpen;
        this.button.setAttribute("aria-expanded", this.isOpen);
        this.menu.setAttribute("aria-hidden", !this.isOpen);
        this.container.dataset.open = this.isOpen;
      }
    }
  
    onClickOutside(e) {
      if (!this.isOpen) return;
  
      let targetElement = e.target;
  
      do {
        if (targetElement == this.container) return;
  
        targetElement = targetElement.parentNode;
      } while (targetElement);
  
      this.toggle();
    }
  
    onKeyEvent(e) {
      if (!this.isOpen) return;
  
      if (e.key === "Tab") {
        this.toggle();
      }
  
      if (e.key === "Escape") {
        this.toggle();
        this.button.focus();
      }
  
      if (e.key === "ArrowDown") {
        this.activeIndex =
          this.activeIndex < this.items.length - 1 ? this.activeIndex + 1 : 0;
        this.items[this.activeIndex].focus();
      }
  
      if (e.key === "ArrowUp") {
        this.activeIndex =
          this.activeIndex > 0 ? this.activeIndex - 1 : this.items.length - 1;
        this.items[this.activeIndex].focus();
      }
    }
}
  
const dropdowns = document.querySelectorAll(".FiltersDropdown");
dropdowns.forEach((dropdown) => new Dropdown(dropdown).initEvents());
 
window.checkUnits = () => {
  const cartList = document.querySelector(".Cart__ItemList");

  let shoeUnit = localStorage.getItem('shoe') ? localStorage.getItem('shoe') : 'uk';
  let cmUnit = localStorage.getItem('cm') ? localStorage.getItem('cm') : 'cm';

  let shoeItems = document.querySelectorAll('.CartItem__Variant.shoe [data-unit="'+shoeUnit+'"]'),
      cmItems = document.querySelectorAll('.CartItem__Variant.cm [data-unit="'+cmUnit+'"]');

  document.querySelectorAll('.CartItem__Variant [data-unit]').forEach(unit => {
    unit.style.display = 'none';
  });

  shoeItems.forEach(unit => {
    unit.style.display = 'inline-block';
  });

  cmItems.forEach(unit => {
    unit.style.display = 'inline-block';
  });
}


window.sizes = () => {
  document.querySelectorAll('.sizes-toggle').forEach(sizeToggle => {
    if(sizeToggle){
      let element = sizeToggle.closest('.Collapsible'),
            sizeType = sizeToggle.dataset.type,
            storedUnit = localStorage.getItem(sizeType),
            variantDropdownLabel = document.querySelectorAll('.ProductForm__Option [data-variant-unit]');

      if(!storedUnit){
        if(sizeType == 'shoe')
          storedUnit = 'uk';
        if(sizeType == 'cm')
          storedUnit = 'cm';
      }
            
      element.querySelectorAll('input[name="sizeUnitShoe"], input[name="msizeUnitShoe"], input[name="sizeUnitCM"], input[name="msizeUnitCM"]').forEach((input) => {
        input.addEventListener('change', (e) => {
          let unit = e.target.value,
              currentUnit = element.querySelectorAll(".size-unit[data-unit='"+unit+"']"),
              allUnits = element.querySelectorAll(".size-unit");
  
          localStorage.setItem(sizeType, unit);
  
          allUnits.forEach((item) => {
            item.style.display = 'none'
          });
          currentUnit.forEach((item) => {
            item.style.display = 'inline-block'
          });
  
          if(variantDropdownLabel){
            variantDropdownLabel.forEach(label => {
              if(label.getAttribute('data-variant-unit') == unit){
                label.style.display = 'inline-block';
              } else {
                label.style.display = 'none';
              }
            });
          }
        });
      });
  
      let unitInputs = element.querySelectorAll('input[value="'+storedUnit+'"]')
  
      unitInputs.forEach((input) => {
        input.checked = true;
        input.dispatchEvent(new Event('change'));
      });
    } 
  });
}
window.sizes();

document.addEventListener('variant:changed', function(event) {
  let deliveryTime = document.querySelector('.ProductForm__EstimatedDelivery .time'),
      addToCart = document.querySelector('.ProductForm__AddToCart'),
      variant = event.detail.variant,
      lowStockQty = document.querySelector('.ProductForm__LowQty'),
      sku = document.querySelector('.ProductMeta__SkuNumber')

  let stockLevel = window.variantsStock[variant.id];

  

  if(stockLevel > 0) {
    deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.standard;
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.standard;
    }
  } else {
    if(window.variantsDeliveryTimePreorder[variant.id]){
      deliveryTime.querySelector('span').innerHTML = window.variantsDeliveryTimePreorder[variant.id];
    } else {
      deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.preorder;
    }
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.preorder;
    }
  }

  if(lowStockQty){
    if(stockLevel > 0 && stockLevel < 3){
      lowStockQty.querySelector('span').innerHTML = stockLevel;
      lowStockQty.style.display = 'block';
    } else {
      lowStockQty.style.display = 'none';
    }
  }
  
  if(sku) {
  	sku.innerHTML = variant.sku 
  }
});

document.addEventListener('theme:loading:start', function(){
  document.querySelector('body').style.cursor = 'wait';
});

document.addEventListener('theme:loading:end', function(){
  setTimeout(function(){
    checkUnits();
    document.querySelector('body').style.cursor = 'default';
  },500);
});

const hasSwatches = document.querySelectorAll('.ProductItem__Swatches');
const loadSwatches = function(){
  fetch('/collections/api?view=json')
    .then(response => response.json())
    .then(data => {
      const products = data;
      let relatedProducts = document.querySelectorAll('[data-handle]');

      relatedProducts.forEach(function(item){
        let handle = item.dataset.handle

        if(products.hasOwnProperty(handle)) {
          item.setAttribute('href', products[handle].url);
          item.querySelector('.item__Bg').style.backgroundImage = 'url('+products[handle].image+')'
        } else {
          item.remove();
        }
      });

      let swatches = document.querySelectorAll('.isSwatch');
      swatches.forEach(function(swatch){
        let count = swatch.querySelectorAll('.item--swatch').length
        if(count < 2) {
          swatch.classList.remove('isSwatch');        
        } else if(count > 4) {
          swatch.querySelector('.item--more span').innerHTML = parseFloat(count)-3
          swatch.querySelector('.item--more').style.display = 'block';
        } else {
          //swatch.querySelector('.item--more').remove();
        }
      });
    });
}
if(hasSwatches) {
  loadSwatches();
}

let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

let shortLang = lang;
if (shortLang.indexOf('-') !== -1)
    shortLang = shortLang.split('-')[0];

if (shortLang.indexOf('_') !== -1)
    shortLang = shortLang.split('_')[0];

// if((shortLang != 'de' || shortLang != 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker-com.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }

// if((shortLang == 'de' || shortLang == 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }


// Cart counter watch
let observer = new MutationObserver(function(mutationsList, observer) {
    mutationsList.forEach(mutation => {
        if(parseInt(mutation.target.innerText) == '0'){
            mutation.target.classList.remove('is-visible');
        } else {
            mutation.target.classList.add('is-visible');
        }
    });
});
observer.observe(document.querySelector('.Header__Icon .Header__CartCount'), {
    characterData: false, 
    childList: true, 
    attributes: false
});



// Shoepassion Customs
jQuery(document).ready(function(){
  jQuery('[data-submit-newsletter]').on('click', function(e){
    e.preventDefault();
    jQuery('.Footer__Block--newsletter form [type="submit"]').click();
  });

  // Search
  let $search_form = $('.Header__Search');
  $('body').on('click', function(){
    if(matchMedia('only screen and (min-width: 1140px)').matches && matchMedia('only screen and (max-width: 1459px)').matches){
      $search_form.hide();
    }
  });
  $('.Header__Icon--search').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    if(matchMedia('only screen and (min-width: 1140px)').matches && matchMedia('only screen and (max-width: 1459px)').matches){
      $search_form.show();
    }
  });
  $('.Header__Search').on('click', function(e){
    e.stopPropagation();
  });

  // Accordion
  let $headings = jQuery('.Accordion__Item-Heading'),
      $contents = jQuery('.Accordion__Item-Content');
  $headings.on('click', function(){
    let $heading = jQuery(this),
        $content = jQuery(this).next();
    $headings.not($heading).removeClass('active');
    $contents.not($content).slideUp(350);
    $heading.toggleClass('active');
    $content.slideToggle(350);
  });

  // Footer
  let $footer_titles = jQuery('.Footer__Block--links .Footer__Title'),
      $footer_lists = jQuery('.Footer__Block--links .Linklist');
  $footer_titles.on('click', function(){
    let $title = jQuery(this),
        $list = jQuery(this).next();
    $footer_titles.not($title).removeClass('active');
    $footer_lists.not($list).slideUp(350);
    $title.toggleClass('active');
    $list.slideToggle(350);
  });

  // Featured Items Slider
  let featured_items_slider = undefined;

  // Filters
  $('.Filters__Button').on('click', function(e){
    if( $(this).attr('aria-expanded') == 'false' ){
      $(this).attr('aria-expanded', true);
      $('.CollectionInner__Filters').addClass('show-all');
    } else {
      $(this).attr('aria-expanded', false);
      $('.CollectionInner__Filters').removeClass('show-all');
    }
  });

  // PDP Swatches
  $('.ProductForm .ColorSwatchList .HorizontalList__Item--more button').on('click', function(){
    $(this).attr('aria-expanded', true);
    $('.ProductForm .ColorSwatchList .ColorSwatchPhoto').show();
  });
  if( $('.ProductForm .ColorSwatchList .ColorSwatch.is-active').parent().index() > 5 ){
    $('.ProductForm .ColorSwatchList .HorizontalList__Item--more button').attr('aria-expanded', true);
    $('.ProductForm .ColorSwatchList .ColorSwatchPhoto').show();
  }

  $('.ProductForm .SizeSwatchList .Linklist__Checkbox').on('change', function(){
    let $collapsible_button = $(this).parents('.Collapsible').find('.Collapsible__Button');
    $(this).parent().find('.size-unit').each(function(){
      let unit = $(this).data('unit').toLowerCase(),
          value = $(this).text();
      $collapsible_button.attr('aria-expanded', false);
      if(unit == 'none') {
      	$collapsible_button.find('[data-variant-unit]').text(value);
      } else {
      	$collapsible_button.find('[data-variant-unit="'+unit+'"]').text(value);
      }
      
    });
  });

  $('body').on('click', function(e){
    if( !$(e.target).parents('.Collapsible').length ){
      $('.ProductForm__Variants .Collapsible__Button').attr('aria-expanded', false);
    }
  });
  
  $('.ProductForm__Variants .Collapsible__HeaderClose').on('click', function(){
    $('.ProductForm__Variants .Collapsible__Button').attr('aria-expanded', false);
  });


  $('.Linklist__Notify button').on('click', function(){
    $(this).parents('.Linklist__Item').find('label').click();
    setTimeout(function(){
      $('.ct_main .ct_button').trigger('click');
    }, 500);
  });

  $('[data-show-product-description]').on('click', function(){
    let $dsc = $('.ProductMeta__Description .Collapsible').eq(0).find('.Collapsible__Button');
    if($dsc.attr('aria-expanded') == 'false'){
      $dsc.click();
    }
    $('html, body').animate({
      scrollTop: $dsc.offset().top
    }, 500);
  });

  $('[data-scroll-to-reviews]').on('click', function(){
    let $el = $('[data-collapsible-reviews]');
    if($el.attr('aria-expanded') == 'false'){
      $el.click();
    }
    $('html, body').animate({
      scrollTop: $el.offset().top
    }, 500);
  });
  
  // Drawer
  $('body').delegate('.Drawer .Collapsible__Button', 'click', function(){
    var $collapsible = $(this).parents('.Drawer').find('.Collapsible'),
        $this_collapsible = $(this).parents('.Collapsible'),
        $header = $(this).parents('.Drawer').find('.Drawer__Heading'),
        $bottom = $(this).parents('.Drawer').find('.Drawer__Bottom');
    if($(this).attr('aria-expanded') == 'true'){ 
      $collapsible.not($this_collapsible).css('display', 'none');
      $this_collapsible.css('display', 'block');
      $header.css('display', 'none');
      $bottom.css('display', 'none');
    } else {
      $collapsible.css('display', 'block');
      $header.css('display', 'flex');
      $bottom.css('display', 'block');
    }
  });
  $('body').delegate('[data-action="close-drawer"]', 'click', function(){
    $(this).parents('.Drawer').find('.Collapsible').css('display', 'block');
    $(this).parents('.Drawer').find('.Drawer__Heading').css('display', 'flex');
    $(this).parents('.Drawer').find('.Collapsible__Button').attr('aria-expanded', false);
  });

  // Brand products
  $('[data-load-brand-products]').on('click', function(){
    $(this).attr('aria-expanded', true);
    $(this).parents('.SectionFooter').hide();
    $(this).parents('.BrandProducts').find('.BrandProducts__Item').addClass('BrandProducts__Item--show');
  });

  let $product_item_image = $('.ProductList .Grid__Cell').eq(0).find('.AspectRatio'),
      $collection_banner = $('.ProductList .Grid__Cell--banner');

  $(window).on('resize', function(){
    if(matchMedia('only screen and (max-width: 599px)').matches){
      if(featured_items_slider === undefined){
        featured_items_slider = $('.FeaturedItems__Slider').flickity({
          arrowShape: 'M73.8,0.2c1,0,1.9,0.4,2.6,1.1c1.5,1.5,1.5,3.8,0,5.3L33,49.9l43.4,43.4c1.5,1.5,1.5,3.8,0,5.3s-3.8,1.5-5.3,0L22.5,49.9L71.1,1.2C71.9,0.5,72.8,0.2,73.8,0.2z'
        });
      }
    } else {
      if(featured_items_slider !== undefined){
        featured_items_slider.flickity('destroy');
        featured_items_slider = undefined;
      }
    }
    if($collection_banner.length){
      $collection_banner.css('height', $product_item_image.height());
    }
  });

  

  $(window).trigger('resize');
});


jQuery(document).ready(function ($) {
  let url = "https://sp-tools.herokuapp.com/sp/de"
  let domain = window.location.hostname
  if (domain.includes("shoepassion.de")) {
    url = "https://sp-tools.herokuapp.com/sp/de"
  } else if (domain.includes("shoepassion.fr")) {
    url = "https://sp-tools.herokuapp.com/sp/fr"
  } else if (domain.includes("shoepassion.ch")) {
    url = "https://sp-tools.herokuapp.com/sp/ch"
  } else if (domain.includes("shoepassion.com")) {
    url = "https://sp-tools.herokuapp.com/sp/en"
  }

//Blog Post Images 
  let all_post_images = document.querySelectorAll('main img');
  let array_of_images = Array.from(all_post_images);

  array_of_images.forEach(element => {
      if (element.src.includes("https://cdn.shoepassion.de/skin/frontend/default/shoepassion/images")) {
        element.src = element.src.replace('cdn', 'old')
      }
    }
  )


  $.ajax({
    url: url,
    dataType: 'json',
    success: function (data) {

      $("#section-header").html(data.header)
      $("#mobile-burger-menu").html(data.header_extra)
      $("#section-footer").html(data.footer)


      //site -switch i guess, not sure


      /*       document.querySelector('.SelectButton').addEventListener("click", (e) => {
              document.querySelector('#localization_form_header .Popover').setAttribute("aria-hidden", false);
            })

            document.querySelector("body").addEventListener("click", (e) => {

              if (!e.target.classList.contains("SelectButton")) {
                document.querySelector('#localization_form_header .Popover').setAttribute("aria-hidden", true);;
              }
            }); */

      // changing link of the site-switcher

      /*       let wp_siteswitcher_options = Array.from(document.querySelectorAll('#localization_form_header .Popover__Value'));
            let WP_widget_language_options = Array.from(document.querySelectorAll('.widget.widget_mslswidget a'));

            let german_site_link = "/";
            let english_site_link = "/";

            WP_widget_language_options.forEach(el => {
              if (el.innerHTML == "DE") {
                german_site_link = el.href;
              } else if (el.innerHTML == "EN") {
                english_site_link = el.href;
              }
            });

            wp_siteswitcher_options.forEach(el => {
              if (el.innerHTML == "DE") {
                el.setAttribute('href', german_site_link)
              } else if (el.innerHTML == "EN") {
                el.setAttribute('href', english_site_link)
              }
            }); */

      // Function for search query in Wordpress
      document.querySelector('.Header__Search').addEventListener("submit", submit_search);

      // Footer
      const $footer_titles = $('.Footer__Block--links .Footer__Title');
      const $footer_lists = $('.Footer__Block--links .Linklist');

      $footer_titles.on('click', function () {
        const $title = $(this);
        const $list = $(this).next();

        $footer_titles.not($title).removeClass('active');
        $footer_lists.not($list).slideUp(350);
        $title.toggleClass('active');
        $list.slideToggle(350);
      });

      let shopify_megamenu = document.querySelector(".Header__MainNav .HorizontalList.HorizontalList--gender[data-gender-menu='men']");
      shopify_megamenu.classList.add("show");

      jQuery('[data-submit-newsletter]').on('click', function (e) {
        e.preventDefault();
        jQuery('.Footer__Block--newsletter form [type="submit"]').click();
      });

      // Drawer
      $('body').delegate('.Drawer .Collapsible__Button', 'click', function () {
        var $collapsible = $(this).parents('.Drawer').find('.Collapsible'),
          $this_collapsible = $(this).parents('.Collapsible'),
          $header = $(this).parents('.Drawer').find('.Drawer__Heading'),
          $bottom = $(this).parents('.Drawer').find('.Drawer__Bottom');
        if ($(this).attr('aria-expanded') == 'true') {
          $collapsible.not($this_collapsible).css('display', 'none');
          $this_collapsible.css('display', 'block');
          $header.css('display', 'none');
          $bottom.css('display', 'none');
        } else {
          $collapsible.css('display', 'block');
          $header.css('display', 'flex');
          $bottom.css('display', 'block');
        }
      });
      $('body').delegate('[data-action="close-drawer"]', 'click', function () {
        $(this).parents('.Drawer').find('.Collapsible').css('display', 'block');
        $(this).parents('.Drawer').find('.Drawer__Heading').css('display', 'flex');
        $(this).parents('.Drawer').find('.Collapsible__Button').attr('aria-expanded', false);
      });

    }
  });
});



// Function for search query in Wordpress
function submit_search(e) {
  e.preventDefault();

  const Search__Input = document.querySelector('.Header__Search .Search__Input').value;
  const search_link = window.location.origin.replace("journal", "www") + "/search?q=" + Search__Input + "&type=product";

  window.location = search_link;
}

// Function for HD mobile Nav Menu

function mobile_burger_menu_open() {
  document.querySelector('.PageOverlay').classList.add("is-visible");
  document.querySelector('#sidebar-menu').setAttribute("aria-hidden", false);
  document.querySelector('#sidebar-menu').style.maxHeight = "100%";
  document.querySelector('html').classList.add("no-scroll");
}

function mobile_burger_menu_close() {
  document.querySelector('.PageOverlay').classList.remove("is-visible");
  document.querySelector('#sidebar-menu').setAttribute("aria-hidden", true);
  document.querySelector('html').classList.remove("no-scroll");
}

function search_bar_close() {
  document.querySelector('#Search').setAttribute("aria-hidden", true);
}



function add_taxonomy_class_name() {
  const all_category_tags_postgrid = document.querySelectorAll('.lsow-module-entry-text .lsow-module-meta span a');

  if (all_category_tags_postgrid) {
    Array.from(all_category_tags_postgrid).forEach(el => {
      const new_classname = el.innerHTML.toLocaleLowerCase();
      el.classList.add(new_classname);
    })
  }
}

add_taxonomy_class_name();

const pagination_button = document.querySelectorAll(".lsow-pagination a");
pagination_button.forEach(el => {
  el.addEventListener("click", () => {
    setTimeout(() => {
      add_taxonomy_class_name()
    }, 500);
  });
})